import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";

export const UpgradeModal = ({ open, onClose, feature = "this feature" }) => {
  const navigate = useNavigate();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="upgrade-modal">
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-md" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white border border-slate-200 rounded-3xl p-8 animate-fade-up shadow-[0_30px_80px_-20px_rgba(15,23,42,0.25)]">
        <div className="flex justify-center mb-5">
          <div className="w-16 h-16 rounded-2xl bg-[#1D6AFF]/10 border border-[#1D6AFF]/25 flex items-center justify-center">
            <Lock className="w-7 h-7 text-[#1D6AFF]" />
          </div>
        </div>
        <h3 className="font-display text-3xl font-bold text-center text-slate-900 mb-3">Unlock {feature}</h3>
        <p className="text-center text-slate-500 mb-7 leading-relaxed">
          This is available on the <span className="text-slate-900 font-semibold">Pro ($199/mo)</span> or <span className="text-amber-600 font-semibold">Elite ($397/mo)</span> plan. Upgrade in seconds and start closing more deals today.
        </p>
        <div className="flex flex-col gap-3">
          <button
            data-testid="upgrade-modal-view-plans"
            onClick={() => { onClose?.(); navigate("/dashboard/plans"); }}
            className="w-full bg-[#1D6AFF] hover:bg-[#1552C6] text-white font-semibold rounded-xl py-3.5 transition-all shadow-[0_10px_30px_-8px_rgba(29,106,255,0.45)] flex items-center justify-center gap-2"
          >
            <Sparkles className="w-4 h-4" />
            View Plans
          </button>
          <button
            data-testid="upgrade-modal-later"
            onClick={onClose}
            className="w-full bg-slate-50 hover:bg-slate-100 text-slate-700 font-medium rounded-xl py-3 border border-slate-200 transition-all"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
